export const qaLabelLogin = {
    signInTitle: 'login--sign-in-title',
    emailInput: 'login--email-input',
    passwordInput: 'login--password-input',
    loginButton: 'login--sign-in-button',
    forgotPasswordLink: 'login--forgot-password-link',
    resetPassValidationMessage: 'login--reset-password-validation-message',
    errorMessage: 'login--error-message'
};
/** Modal inside the login page for sending the reset password link */
export const qaLabelResetPasswordModal = {
    title: 'login--reset-password-modal--title',
    subtitle: 'login--reset-password-modal--subtitle',
    emailInput: 'login--reset-password-modal--email-input',
    submitButton: 'login--reset-password-modal--submit-button'
};
